// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class UTCOffset {
    constructor(offsetHours) {
        this.positive = offsetHours >= 0;
        const absOffsetHours = Math.abs(offsetHours);
        this.hours = Math.trunc(absOffsetHours);
        this.minutes = (absOffsetHours % 1) * 60;
    }
    static padNumber(num, size) {
        let str = num.toString();
        const positive = num >= 0;
        if (!positive)
            str = str.substring(1);
        while (str.length < size)
            str = '0' + str;
        return positive ? str : '-' + str;
    }
    compareTo(utcOffset) {
        return this.totalMinutes() - utcOffset.totalMinutes();
    }
    totalMinutes() {
        const absMinutes = this.hours * 60 + this.minutes;
        return this.positive ? absMinutes : -absMinutes;
    }
    toString() {
        const positive = this.positive;
        const hours = this.hours;
        const minutes = this.minutes;
        if (!hours && !minutes)
            return '';
        return (positive ? '+' : '-') + UTCOffset.padNumber(hours, 2) + ':' + UTCOffset.padNumber(minutes, 2);
    }
}
